import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const CheckSmallIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M18.707 8.707 10.5 16.914l-4.207-4.207 1.414-1.414 2.793 2.793 6.793-6.793z" />
  </BaseIcon>
)
